import React, { ChangeEvent } from 'react';
import ForgotPassword from './ForgotPassword';
import { LOGIN_RESPONSES, BASE_URL, HTTP_URL } from '../constants';
// import Button from '../DumpComponents/Button';
import Modal from '../DumpComponents/Modal';
import './styles.scss';
import { api } from '../utils';
import CheckboxSelected from '../assets/icons/checkbox-selected.svg';
import CheckboxUnselected from '../assets/icons/checkbox-unselected.svg';
import ClosedEyeIcon from '../assets/icons/hide-eye.svg';
import Illustration from '../assets/imgs/logo.svg';
import OpenedEyeIcon from '../assets/icons/show-eye.svg';
import Title from './Group 2123.svg';
import { WaringConfigObject } from '../DumpComponents/Modal/model';
import LoginOTP from '../Components/LoginOTP/LoginOTP';
import LogoutLoader from '../assets/icons/logout-loader.gif';

type Props = {
	setStatus: Function;
	showErrorPopup: Function;
	decidePath: Function;
	getTenant: Function;
};
type State = {
	formValues: {
		[k: string]: string | boolean;
	};
	invalid: boolean;
	logging: boolean;
	showPassword: boolean;
	isForgotPasswordClicked: boolean;
	error: boolean;
	signInBtn: string;
	errorMessage: string;
	checkBox: boolean;
	userName: string;
	showOTPScreen: boolean;
	toasterConfig: {
		isVisible: boolean;
		toasterMessage: '';
	};
	warningConfig: WaringConfigObject;
	needHelpConfig: {
		isVisible: boolean;
		prioritizedOption: 1;
	};
	isValidateLoadState: boolean;
	// tenantData: [];
};

class Login extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = this.setInitialState();
		this.handleTextInput = this.handleTextInput.bind(this);
		this.handleCheckboxInput = this.handleCheckboxInput.bind(this);
		this.login = this.login.bind(this);
		this.callLoginApi = this.callLoginApi.bind(this);
	}

	setInitialState(): State {
		return {
			formValues: {
				email: '',
				password: '',
				consentCheck: false,
			},
			invalid: false,
			logging: false,
			showPassword: false,
			isForgotPasswordClicked: false,
			error: false,
			signInBtn: 'Sign In',
			errorMessage: LOGIN_RESPONSES.INCORRECT_USERNAME_OR_PASSWORD,
			// errorMessage: '',
			checkBox: false,
			userName: '',
			showOTPScreen: false,
			toasterConfig: {
				isVisible: false,
				toasterMessage: '',
			},
			// tenantData: [],
			warningConfig: {
				isVisible: false,
				title: '',
				message: '',
				buttons: [],
			},
			needHelpConfig: {
				isVisible: false,
				prioritizedOption: 1,
			},
			isValidateLoadState: false,
		};
	}

	handleTextInput(e: ChangeEvent<HTMLInputElement>) {
		const fieldName = e.target.id;
		const value = e.target.value;
		this.setState((prev) => {
			return {
				...prev,
				formValues: {
					...prev.formValues,
					[fieldName]: value,
				},
			};
		});
		if (fieldName === 'email') {
			const emailFormat = new RegExp(/(.+)@(.+)\.(.+)/).test(value);
			if (emailFormat) {
				sessionStorage.setItem('userEmail', value);
			}
		}
	}

	handleCheckboxInput(e: ChangeEvent<HTMLInputElement>) {
		const fieldName = e.target.id;
		const value = e.target.checked;
		this.setState((prev) => {
			return {
				...prev,
				formValues: {
					...prev.formValues,
					[fieldName]: value,
				},
			};
		});
	}

	renderToaster = (toasterMessage: any) => {
		this.setState(
			{
				toasterConfig: {
					isVisible: true,
					toasterMessage,
				},
			},
			() => {
				setTimeout(
					() =>
						this.setState({
							toasterConfig: { isVisible: false, toasterMessage: '' },
						}),
					3000
				);
			}
		);
	};

	resetLoginPage = () => {
		// reset username and loginStep1Success in session storage
		// addToSessionStorage(SessionStorageKeys.UserData, 'username', '');
		sessionStorage.setItem('loginStep1Success', '0');
		this.setState(
			{
				error: false,
				errorMessage: '',
				checkBox: false,
				showOTPScreen: false,
				signInBtn: 'Sign In',
				userName: '',
				warningConfig: {
					isVisible: false,
					title: '',
					message: '',
					buttons: [],
				},
				// needHelpConfig: {
				//   isVisible: false,
				//   prioritizedOption: 1
				// }
			},
			() => {
				window.location.reload();
			}
		);
	};
	showWarningForFailedLoginAttempt = (
		title: string,
		message: string,
		buttons: any
	) => {
		this.setState({
			warningConfig: {
				isVisible: true,
				title,
				message,
				buttons,
			},
		});
	};

	handleCloseModal = () => {
		this.setState({
			warningConfig: {
				isVisible: false,
				title: '',
				message: '',
				buttons: [],
			},
		});
	};
	resetOtpInBackend = (userName: any) => {
		return new Promise((resolve) => {
			api('updateOtpRequired', 'POST', {
				clearOtp: true,
				fromBackToSignIn: true,
				userId: userName,
			})
				.then((r) => r.json())
				.then((responseObj) => {
					if (responseObj.ResType === 'Success') {
						resolve(true);
					} else {
						resolve(false);
					}
				})
				.catch((error) => {
					resolve(false);
				});
		});
	};
	login = (validate?: any, username?: any) => {
		sessionStorage.setItem('loginStep1Success', 'false');
		this.setState(
			{
				logging: true,
				signInBtn: 'Wait...',
				warningConfig: {
					isVisible: false,
					title: '',
					message: '',
					buttons: [],
				},
			},
			() => {
				if (this.state.signInBtn === 'Wait...') {
					this.setState({
						isValidateLoadState: true,
					});
				} else {
					this.setState({
						isValidateLoadState: false,
					});
				}
			}
		);

		// console.log(this.state.showOTPScreen);
		if (this.state.showOTPScreen) {
			this.callLoginApi(validate, username);
		} else {
			this.resetOtpInBackend(username ? username : this.state.formValues.email)
				.then((data: any) => {
					this.callLoginApi(validate, username);
				})
				.catch((error: any) => {
					console.log(error);
					this.callLoginApi(validate, username);
				});
		}
	};
	callLoginApi(validate?: any, username?: string) {
		// var pass = document.getElementById('password') as HTMLElement;
		// var otp = pass.getAttribute('value');
		// var storeuserName = username ? username : this.state.formValues.email;
		// var storePassword = otp ? otp : this.state.formValues.password;
		// fetch(HTTP_URL + BASE_URL + '/AwareHybridChat/login', {
		//   //uat
		//   method: 'POST',
		//   body: JSON.stringify({
		//     userId: storeuserName,
		//     password: storePassword,
		//     otp: this.state.showOTPScreen === true ? true : false,
		//     invalidate: validate === true ? true : false,
		//   }),
		//   credentials: 'include',
		// headers: {
		//   Authorization: 'Basic ' + window.btoa(storeuserName + ':' + storePassword),
		// },
		// })
		api('login', 'POST', {
			userId: this.state.formValues.email,
			password: this.state.formValues.password,
			otp: this.state.showOTPScreen === true ? true : false,
			invalidate: validate === true ? true : false,
		})
			.then((data) => {
				// .then((r) => r.json())
				// .then((data) => {
				this.setState({
					signInBtn: 'Sign In',
					isValidateLoadState: false,
				});
				const {
					agentActiveSession,
					agentId,
					message,
					responseCode,
					result,
					roleId,
					userName,
					userEmail,
					userId,
					notify,
					passwordExpireOn,
					forcePasswordReset,
					firstName,
					lastName,
				} = data;

				if (result === 'success') {
					sessionStorage.setItem('agentActiveSession', agentActiveSession);
					sessionStorage.setItem('agentId', agentId);
					sessionStorage.setItem('message', message);
					sessionStorage.setItem('result', result);
					// sessionStorage.setItem('roleId', roleId); //newly commented
					sessionStorage.setItem('firstName', firstName);
					sessionStorage.setItem('lastName', lastName);
					sessionStorage.setItem('userName', userName);
					sessionStorage.setItem('userEmail', userEmail);
					sessionStorage.setItem('userId', userId);
					sessionStorage.setItem('notify', notify);
					sessionStorage.setItem('forcePasswordReset', forcePasswordReset);
					sessionStorage.setItem('passwordExpireOn', passwordExpireOn);
					sessionStorage.setItem('refresh', 'RefreshCalled');
					// this.props.setStatus(true, roleId);
					sessionStorage.setItem('agentLogin', 'Login');
					sessionStorage.setItem('currentSessionID', '');
					sessionStorage.setItem('startsessionID', '');
					sessionStorage.setItem('botsessionID', '');

					if (forcePasswordReset) {
						// Check for forceResetPassword
						this.setState({
							error: true,
							errorMessage: LOGIN_RESPONSES.RESET_PASSWORD,
							// signInBtn: 'Sign In',
						});
					} else {
						//    /**
						//     * This will decide whether to go to TenantSelection page
						//     * or directly in MyHub
						//     * or for Superadmin, some other path
						//     */
						// console.log('hello');
						this.props.getTenant();
					}
				} else {
					switch (responseCode) {
						case 2: {
							this.setState({
								error: true,
								errorMessage: LOGIN_RESPONSES.INCORRECT_USERNAME_OR_PASSWORD,
								isValidateLoadState: false,
							});
							break;
						}
						case 3: {
							this.setState(
								{
									error: true,
									errorMessage:
										this.state.isValidateLoadState === false
											? LOGIN_RESPONSES.INCORRECT_USERNAME_OR_PASSWORD
											: '',
									isValidateLoadState: false,
								},
								() => {
									if (message === '3') {
										this.showWarningForFailedLoginAttempt(
											'3rd failed attempt at sign in',
											LOGIN_RESPONSES.CONSECUTIVE_FAILED,
											[
												{
													title: 'Got it',
													theme: '3',
													onClick: this.handleCloseModal,
												},
											]
										);
									} else {
										this.setState({
											error: true,
											errorMessage: message,
											isValidateLoadState: false,
											// signInBtn: 'Sign In',
										});
										this.showWarningForFailedLoginAttempt(
											'Your account has been locked',
											LOGIN_RESPONSES.ACCOUNT_LOCKED,
											[
												{
													title: 'Later',
													theme: '3',
													onClick: this.handleCloseModal,
												},
												{
													title: 'Set new password',
													theme: '0',
													onClick: () => {
														this.setState(
															{
																isForgotPasswordClicked: true,
															},
															() => {
																this.handleCloseModal();
															}
														);
													},
												},
											]
										);
									}
								}
							);

							break;
						}
						case 4: {
							this.setState(
								{
									error: true,
									errorMessage: message,
									signInBtn: 'Sign In',
									isValidateLoadState: false,
								},
								() => {
									// this.showWarningForFailedLoginAttempt(
									//   'Notice',
									//   LOGIN_RESPONSES.ALREADY_LOGGEDIN,
									//   [{ title: 'Okay', theme: '3', onClick: this.handleCloseModal }]
									// );
									this.showWarningForFailedLoginAttempt(
										'You are already signed in',
										LOGIN_RESPONSES.ALREADY_LOGGEDIN,
										[
											{
												title: 'Cancel',
												theme: '3',
												onClick: this.handleCloseModal,
											},
											{
												title: 'Yes, continue here',
												theme: '0',
												onClick: () => {
													this.login(true);
												},
											},
										]
									);
								}
							);

							break;
						}
						// case 5: {
						//   this.setState({
						//     showOTPScreen: true,
						//     error: false,
						//     errorMessage: '',
						//     signInBtn: 'Submit',
						//   });
						//   sessionStorage.setItem('loginStep1Success', 'true');
						//   break;
						// }
						// case 6: {
						//   this.setState({
						//     error: true,
						//     errorMessage: LOGIN_RESPONSES.IncorrectOTP,
						//     signInBtn: 'Submit',
						//   });
						//   break;
						// }
						// case 7: {
						//   this.renderToaster('OTP authentication failed');
						//   this.resetLoginPage();

						//   break;
						// }
						default: {
							this.setState({
								error: true,
								errorMessage: message,
								isValidateLoadState: false,
								// signInBtn: 'Sign In',
							});
							break;
						}
					}
				}
			})
			.finally(() => {
				this.setState({
					logging: false,
				});
			});
	}
	showForgotPassword = () => {
		if (this.state.isForgotPasswordClicked) {
			this.setState({
				formValues: {
					...this.state.formValues,
					email: '',
					errorMessage: '',
				},
				isForgotPasswordClicked: !this.state.isForgotPasswordClicked,
			});
		} else {
			this.setState({
				isForgotPasswordClicked: !this.state.isForgotPasswordClicked,
			});
		}
	};

	checkBoxClicked = () => {
		this.setState((state) => {
			return {
				checkBox: !state.checkBox,
			};
		});
	};

	togglePassword() {
		this.setState({
			showPassword: !this.state.showPassword,
		});
	}

	render() {
		return (
			<div className='main-container'>
				<div className='login-container'>
					<div className='left-container'>
						<img src={Illustration} alt='sf-logo-background' />
					</div>
					<div className='right-container'>
						<div className='form-stuff'>
							{this.state.isForgotPasswordClicked ? (
								''
							) : (
								<div className='heading'>
									<img src={Title} alt='title' />
									<p>Hybrid Chat</p>
								</div>
							)}
							{this.state.isForgotPasswordClicked ? (
								<ForgotPassword
									showLogin={this.showForgotPassword}
									email={this.state.formValues.email}
									showWarningForFailedLoginAttempt={
										this.showWarningForFailedLoginAttempt
									}
									handleCloseModal={this.handleCloseModal}
								/>
							) : (
								// : this.state.showOTPScreen ? (
								//   <LoginOTP
								//     error={this.state.error}
								//     errorMessage={this.state.errorMessage}
								//     signInBtn={this.state.signInBtn}
								//     checkLogin={this.login}
								//     renderToaster={this.renderToaster}
								//     resetLoginPage={this.resetLoginPage}
								//     email={this.state.formValues.email}
								//   />
								// )
								<form
									onSubmit={(e) => e.preventDefault()}
									style={this.state.invalid ? { marginTop: '24px' } : {}}>
									<div style={{ paddingBottom: 0 }}>
										<input
											type='email'
											id='email'
											className='form-control login-input'
											placeholder='Email'
											onChange={this.handleTextInput}
										/>
										<div style={{ position: 'relative' }}>
											<input
												type={this.state.showPassword ? 'text' : 'password'}
												id='password'
												className='login-input'
												placeholder='Password'
												onChange={this.handleTextInput}
											/>
											<span
												style={{
													position: 'absolute',
													left: '75%',
													top: '20%',
												}}
												title={
													this.state.showPassword
														? 'Hide password'
														: 'Show password'
												}
												className='clickable'>
												<img
													src={
														this.state.showPassword
															? ClosedEyeIcon
															: OpenedEyeIcon
													}
													alt='password'
													onClick={() => this.togglePassword()}
												/>
											</span>
										</div>

										{this.state.error ? (
											<div id='errorMessage'>{this.state.errorMessage}</div>
										) : (
											''
										)}
										<div className='privacy-license-container'>
											<div
												className='privacy-container'
												onClick={() => this.checkBoxClicked()}>
												<span style={{ marginRight: '5px', cursor: 'pointer' }}>
													<img
														src={
															this.state.checkBox
																? CheckboxSelected
																: CheckboxUnselected
														}
														alt='checkbox'
													/>
												</span>
												<span className='mandatory-field'></span>
												<span className='read-accept'>
													I have read and accepted the{' '}
													<span
														className='privacy-url'
														onClick={() => {
															const _win = window.open(
																'https://www.senseforth.ai/privacy-policy/',
																'_blank'
															);
															_win && _win.focus();
														}}>
														Privacy Policy
													</span>
												</span>
											</div>
										</div>
										<input
											type='submit'
											className={`btn btn-primary btn-block sf-login-btn sf-login-btn-width ${
												this.state.signInBtn !== 'Sign In' ? 'disabled' : ''
											} ${this.state.checkBox ? '' : 'disabled'}`}
											value={this.state.signInBtn}
											onClick={() => this.login(false)}
										/>
										<div
											className='fp-onlogin-page'
											onClick={this.showForgotPassword}>
											Forgot Password?
										</div>
									</div>
								</form>
							)}
						</div>
					</div>
				</div>

				{this.state.warningConfig.isVisible ? (
					<Modal
						onClose={this.handleCloseModal}
						styles={{ width: '452px' }}
						warningConfig={this.state.warningConfig}></Modal>
				) : null}
				{this.state.isValidateLoadState ? (
					<div
						className='logout-loader'
						style={{
							width: '100%',
							height: '100%',
						}}>
						<div
							className='logout-inner active-class'
							style={{
								left: '40% !important',
							}}>
							<img src={LogoutLoader} alt='loader' className='loader-icon' />
							<span className='loader-content'>Please wait...</span>
						</div>
					</div>
				) : null}
			</div>
		);
	}
}

export default Login;
